import { Component, Input } from '@angular/core';
import { LicenseInfoComponent } from '../license-info.component';
import { LicenseInterface } from '../../../interfaces/license.interface';
import { LicenseService } from '../../../services/license.service';
import { SidenavService } from '../../../services/sidenav.service';
import { ModuleListComponent } from '../../../license-registration/module-list/module-list.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-edit-modules',
  standalone: true,
  imports: [ModuleListComponent, MatButtonModule],
  templateUrl: './edit-modules.component.html',
  styleUrl: './edit-modules.component.scss'
})
export class EditModulesComponent {
  license!: LicenseInterface;
  that!: LicenseInfoComponent;
  modules: { module_key: string; description: string }[] = [];

  constructor(private licenseService: LicenseService,
              private sidenavService: SidenavService) {}

  @Input() set data(value: { license: LicenseInterface; that: LicenseInfoComponent }) {
    this.license = value.license;
    this.that = value.that;
  }

  moduleChange($event: { module_key: string; description: string }[]) {
    this.modules = $event;
  }

  save() {
    if (!this.license) { return; }
    const data: LicenseInterface = { ...this.license, module_list: this.modules };
    this.licenseService.updateLicense(data).subscribe(() => {
      this.that.init();
      this.sidenavService.sideNavState$.next(false);
    });
  }
}
